import { navigate, StaticQuery } from 'gatsby';
import React from 'react';
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { getImage } from '../utils';
import Truncate from 'react-truncate';
import { graphql } from 'gatsby';

const Item = ({
    title,
    image,
    alt,
    slug
}) => {
    const goTo = () =>
        navigate(slug)

    return (
        <div
            onClick={goTo}
            className="c-pointer bg-white">
            <div className="container-card-overlay">
                <img
                    style={{
                        height: "250px",
                        objectFit: "cover"
                    }}
                    src={image}
                    alt={alt}
                    className="img-fluid w-100" />
                <div className="card-overlay">
                    <Truncate trimWhitespace={true} lines={2} ellipsis={<span>...</span>}>
                        {title}
                    </Truncate>
                </div>
            </div>
        </div>
    )
}

const ProjectRoll = ({
    title = "Tenemos la casa que siempre has soñado, en un lugar lleno de comodidades y seguridad.",
    data
}) => {
    const arr = data.allMarkdownRemark.edges;
    const edges = arr.map(item => ({
        ...item,
        node: {
            ...item.node,
            frontmatter: {
                ...item.node.frontmatter,
                image: {
                    ...item.node.frontmatter.image,
                    featuredimage: getImage(item.node.frontmatter.image, "featuredimage")
                }
            }
        }
    }))

    const values = {
        allMarkdownRemark: {
            edges
        }
    }

    const projs = values.allMarkdownRemark.edges;

    return (
        <>
            <section
                className="container-fluid py-5 bg-light">
                <div className="container">
                    <h3 className="text-center font-weight-bold">
                        {title}
                    </h3>
                    {/* Displayed in desk */}
                    <div className="d-none d-md-block">
                        <div className="row mt-5">
                            {
                                projs.map((item, index) => {
                                    return (
                                        <div
                                            key={`projdesktop${index}`}
                                            className={`col-md-6 col-lg-4 px-2 mb-4`}>
                                            <Item
                                                image={item.node.frontmatter.image.featuredimage}
                                                alt={item.node.frontmatter.image.alt}
                                                title={item.node.frontmatter.name}
                                                slug={item.node.fields.slug} />
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                    {/* Displayed in mobile */}
                    <div className="d-block d-md-none">
                        <Carousel showStatus={false} showThumbs={false} emulateTouch>
                            {
                                projs.map((item, index) => (
                                    <div
                                        style={{ backgroundColor: "transparent" }}
                                        className="px-md-0 pb-5">
                                        <div
                                            key={`projmobile${index}`}>
                                            <Item
                                                image={item.node.frontmatter.image.featuredimage}
                                                alt={item.node.frontmatter.image.alt}
                                                title={item.node.frontmatter.name}
                                                slug={item.node.fields.slug} />
                                        </div>
                                    </div>
                                ))
                            }
                        </Carousel>
                    </div>
                </div>
            </section>
        </>
    )
}

// export default ProjectRoll;

export default props => (
    <StaticQuery
        query={graphql`
        query ProjectRoll {
            allMarkdownRemark(
                sort: { order: DESC, fields: [frontmatter___date] }
                filter: { frontmatter: { templateKey: { eq: "project-post" } }}
                limit: 6
            ) {
                edges {
                    node {
                        fields {
                            slug
                        }
                        frontmatter {
                            name
                            image {
                                featuredimage {
                                  childImageSharp {
                                      fluid {
                                          ...GatsbyImageSharpFluid
                                      }
                                  }
                                  publicURL
                                }
                                alt
                            }
                        }
                    }
                }
            }
        }
      `}
        render={(data, count) => <ProjectRoll data={data} title="Tenemos la casa que siempre has soñado, en un 
        lugar lleno de comodidades y seguridad." {...props} />}
    />
)